import React, { useState, useMemo, useRef, useImperativeHandle, forwardRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import { FormRef } from 'devextreme-react/form';
import 'devextreme-react/text-area';

import Assistant from '../ai-assistant-chat/assistant';

interface AIAssistantChatPopupProps {

}

export interface AIAssistantChatPopupHandle {
    Open: (aiGroupId: number) => void;
}

const AIAssistantChatPopup = forwardRef<AIAssistantChatPopupHandle, AIAssistantChatPopupProps>(({ }, ref) => {

    const formRef = useRef<FormRef>(null);

    const [isOpen, setIsOpen] = useState(false);

    const [aiGroupId, setAIAssistantId] = useState<number | null>(null);

    useImperativeHandle(ref, () => ({
        Open(aiGroupId: number) {
            setAIAssistantId(aiGroupId);
            setIsOpen(true);
        }
    }));

    const closeDialog = () => {
        setIsOpen(false);
    };

    const popupAttributes = useMemo(() => {
        return {
            id: 'elementId',
            class: 'class-name-popup'
        }
    }, []);

    return (
        <Popup
            wrapperAttr={popupAttributes}
            visible={isOpen}
            onHiding={closeDialog}
            dragEnabled={false}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            title="AI Assistant"
            container=".dx-viewport"
            width={800}
            height={800}
        >
            <Assistant aiGroupId={aiGroupId} enabled={isOpen} />
        </Popup>
    );
});

export default AIAssistantChatPopup;